import React from 'react';
import PropTypes from 'prop-types';
import {useAsync} from 'react-use';

import {getUser} from '@/api/users';

UserExtLabel.propTypes = {
    userId: PropTypes.string.isRequired,
    /**
     * 是否显示括号
     */
    bracket: PropTypes.bool,
    className: PropTypes.string,
    style: PropTypes.object,
};

function UserExtLabel({userId, bracket = true, className, style}) {
    const {value, loading} = useAsync(() => {
        return getUser(userId, {custom: {showErrorNotification: false}})
            .then(({data}) => {
                return data?.extId;
            })
            .catch(() => {
                return null;
            });
    }, [userId]);

    if (loading || !value) {
        return null;
    }

    return (
        <span className={className} style={style}>
            {bracket ? `(${value})` : value}
        </span>
    );
}

export default UserExtLabel;
